<!-- Stars Reviews -->
<div
  [class]="backgroundInfo.url ? textColorOverride + ' bg-no-repeat bg-center bg-cover' : backgroundInfo"
  [style.backgroundImage]="backgroundInfo.url && 'url(' + backgroundInfo.url + ')'"
  >
  <div class="container {{ containerClasses }}">
    @if (title) {
      <div class="wysiwyg sm:px-v-spacing max-w-container mx-auto" [innerHTML]="title"></div>
    }
    <div
      class="flex flex-wrap flex-col lg:flex-row text-center justify-center items-center mb-v-spacing py-v-spacing sm:px-v-spacing"
      >
      <div class="text-lg font-bold mb-v-spacing md:mb-0 leading-tight">What students say about AceableAgent</div>
      <div class="flex flex-col xs:flex-row items-center">
        <div class="stars pb-v-spacing xs:pb-0 px-v-spacing">
          @for (star of fiveStars; track star) {
            <fa-icon class="star text-md fa-1x" [icon]="faStar"></fa-icon>
          }
        </div>
        <div class="text-base"><strong>4.9</strong>/5 <span class="mx-v-spacing">|</span> Over 6,000 reviews</div>
      </div>
    </div>
    <div class="flex md:flex-row flex-col justify-center">
      @for (review of starsReviews; track review) {
        <div
          class="md:w-1/3 w-full bg-white mx-0 mb-8 md:mr-v-spacing p-v-spacing text-vis-regular"
        [ngClass]="{
          'max-w-container mx-auto': starsReviews.length === 1
        }"
          >
          <div class="inline-flex">
            @for (star of fiveStars; track star) {
              <fa-icon class="star text-base fa-1x" [icon]="faStar"></fa-icon>
            }
          </div>
          <div class="inline-flex text-xs my-v-spacing ml-v-spacing font-semibold">{{ review.name }}</div>
          <div class="text-base text-vis-regular font-extrabold mb-v-spacing">{{ review.header }}</div>
          <div class="text-xs font-light">{{ review.review }}</div>
        </div>
      }
    </div>
  </div>
</div>
